module.exports = __webpack_public_path__ + "img/qikan.94af438c.png";